import { useConfigStore } from 'src/hooks/settings';

export const getAPiVersion = () => {
  return useConfigStore.getState().config?.api_version || 'v1';
};

export * from './auth';
export * from './chat';
export * from './misc';
export * from './form';
export * from './patientDocument';
export * from './appointment';
